<template>
  <div class="com-cart-add b_white">
    <van-form label-width="75px" label-align="right" @submit="onSubmit">
      <van-cell-group inset>
        <van-field
          v-model="form.name"
          name="车主姓名"
          label="车主姓名:"
          placeholder="请输入车主姓名"
          :rules="[{ required: true, message: '请输入车主姓名' }]"
        />
        <van-field
          v-model="form.tel"
          name="手机号"
          label="手机号:"
          placeholder="请输入手机号"
          maxLength="11"
          type="tel"
          :rules="telRules"
        />
        <van-field
          v-model="form.licensePlateNum"
          name="车牌号"
          label="车牌号:"
          placeholder="请输入车牌号"
          :rules="licensePlateRules"
          @input="inputHandler"
        />
        <van-field
          v-model="form.idCard"
          name="身份证号"
          label="身份证号:"
          placeholder="非必填项"
          @input="inputHandlerIdCard"
        />
        <!-- :rules="[{ required: true, message: '请输入车牌号' }, { checkLicensePlate, message: '请输入正确的车牌号' }]" -->
      </van-cell-group>
      <div class="add-bottom">
        <van-button round block type="primary" native-type="submit">
          保存
        </van-button>
        <div class="footer_iphone"></div>
      </div>
    </van-form>
  </div>
</template>
<script>
// import { Toast } from 'vant';
import { mapState } from "vuex";
import { Toast } from "vant";

export default {
  data() {
    return {
      form: {
        name: "",
        tel: "",
        licensePlateNum: "",
        idCard: "",
        cusBoId: "",
        validateCust: "",
        cusId: ""
      },
      telRules: [
        {
          required: true,
          message: "请输入手机号"
        },
        {
          // eslint-disable-next-line
          validator: value => /^\d{11}/gi.test(value),
          message: "请输入正确的手机号",
          trigger: "onBlur"
        }
      ],
      licensePlateRules: [
        {
          required: true,
          message: "请输入车牌号"
        },
        {
          // eslint-disable-next-line
          validator: value =>
            /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([A-Z0-9]{4,5}[A-Z0-9挂学警港澳]{1}$)|([0-9]{4,5}[DF]$)|([DF][A-HJ-NP-Z0-9][0-9]{4,5}$))/.test(
              value
            ),
          message: "请输入正确的车牌号",
          trigger: "onBlur"
        }
      ]
    };
  },
  computed: mapState({
    userInfo: state => state.app.userInfo
  }),
  created() {
    const { query } = this.$route;

    if (query.id) {
      this.form = {
        ...query
      };
    }
    if (this.$route.query.cusBoId) {
      this.form.cusBoId = this.$route.query.cusBoId;
    }
    if (this.$route.query.validateCust) {
      this.form.validateCust = this.$route.query.validateCust;
    }
    if (this.$route.query.cusId) {
      this.form.cusId = this.$route.query.cusId;
    }
  },
  methods: {
    inputHandler(value) {
      const newValue = value.substring(0, 8);
      this.form.licensePlateNum = newValue;
    },
    inputHandlerIdCard(value) {
      const newValue = value.substring(0, 18);
      this.form.idCard = newValue;
    },
    onSubmit() {
      const url = this.form.id ? "comCart/membervehicleEdit" : "comCart/addVehicle";
      this.$store.dispatch(url, this.form).then(res => {
        console.log(res);
        if (res.code === "0") {
          Toast.success(this.form.id ? "保存成功！" : "添加成功！");
          setTimeout(() => {
            this.$router.push({
              path: `/comcart?cusBoId=${this.form.cusBoId}&validateCust=${this.form.validateCust}&cusId=${this.form.cusId}`
            });
          }, 1000);
        } else {
          Toast.fail(res.msg);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./add.scss";
</style>
